<template>
    <b-modal v-bind:id="'nikud-whole-keyboard-popup-'+whichKeyboard"
             ref="'nikud-whole-keyboard-popup"
             centered
             body-class="pb-0"
             ok-title="החל"
             @ok="$store.commit('SET_NIKUD_KEYBOARD', whichKeyboard); showChangedKeyboardMessage()"
             cancel-title="ביטול"
             size="lg">
        <template slot="modal-header"><div>{{ explanationText[whichKeyboard] }}</div></template>
        <!-- hiding print button for now
        <div class="mb-2 text-left">
            <b-button size="sm" variant="link" class="px-1" @click="printPopup">
                <i class="fa fa-print ml-1"></i>הדפסה
            </b-button>
        </div>
        -->
        <img v-if="whichKeyboard==='old'" src="../assets/keyboard-keys-old.png" class="img-fluid" id="kbd" />
        <img v-if="whichKeyboard==='new'" src="../assets/keyboard-keys-new.png" class="img-fluid" id="kbd" />
        <img v-if="whichKeyboard==='blind'" src="../assets/keyboard-keys-blind.png" class="img-fluid" id="kbd" />
        <div class="mr-2 mt-2 mb-0">
            קמץ קטן&nbsp;&nbsp;
            <button type="button" class="btn btn-link keyboard-btn">
                <span v-if="whichKeyboard==='old'">8</span>
                <span v-if="whichKeyboard==='new'">E/ק</span>
                <span v-if="whichKeyboard==='blind'">L</span>
            </button> + <button type="button" class="btn btn-link keyboard-btn">Shift</button> + <button type="button" class="btn btn-link keyboard-btn">Alt</button>
        </div>
    </b-modal>
</template>

<script>
    // @ is an alias to /src
    import nikudMixins from '@/mixins/nikudMixins'
    import Printd from 'printd'

    export default {
        name: "keyboard-keys-popup",
        props: ['whichKeyboard'],
        mixins: [nikudMixins], // for showChangedKeyboardMessage()
        data () {
            return {
                showKeyboardPopup: false,
                explanationText: {
                    new: 'שיטת ניקוד חדשה (אותיות)',
                    old: 'שיטת ניקוד ישנה (מספרים)',
                    blind: 'שיטת ניקוד בהקלדה עיוורת'
                }
            }
        },
        methods: {
            printPopup () {
                const d = new Printd()
                d.print(document.getElementById('kbd'))
            }
        }
    }

</script>

<style scoped>
    .keyboard-btn {
        border: 1px solid #D1D0D0;
        border-radius: 3px;
        padding: 4px 8px;
        min-width: 30px;
        height: 28px;
        font-size: 16px;
        line-height: 2px;
        background: #fff;
        box-shadow: 0 1px 0 0 rgba(0,0,0,.17);
        margin-left: 1px;
        cursor: text !important;
    }
    .keyboard-btn:focus, .keyboard-btn:active
    {
        box-shadow: 0 1px 0 0 rgba(0, 0, 0, .17) !important;
    }
</style>